import { useTranslation } from '../../../i18n';
import { Button } from '../../../components/Shared/Button';

interface BillableRunFooterProps {
  /** Already-translated selection summary („3 von 5 Objekten ausgewählt — …“). */
  summary: string;
  submitLabel: string;
  disabled: boolean;
  saving: boolean;
  onSubmit: () => void;
}

/** Summary + submit bar under a proposal-list table (monthly run and standing invoices). */
export function BillableRunFooter({
  summary, submitLabel, disabled, saving, onSubmit,
}: BillableRunFooterProps) {
  const { t } = useTranslation(['common']);
  return (
    <div className="rounded-xl border border-slate-200 bg-white px-4 py-3">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="text-[13px] text-slate-600">{summary}</div>
        <Button onClick={onSubmit} disabled={disabled || saving}>
          {saving ? t('common:actions.saving') : submitLabel}
        </Button>
      </div>
    </div>
  );
}
